<router-outlet></router-outlet>

@if(showChat()) {
  <div class="chat-icon">
    <app-chat />
  </div>
}
